import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { settingsActions } from '../store/reducers/settings';

const AuthRoute = ({ settingsData, isScreenLoad, settingsError }: any) => {
  const auth = useAuth();
  const navigate = useNavigate();
  const authUserId = get(auth, 'user.profile.sub', '');
  const dispatch = useDispatch();

  useEffect(() => {
    if (auth && !auth.isLoading) {
      if (auth.isAuthenticated) {
        // dispatch(settingsActions.getSettingsDataRequest(''));
        navigate('/dashboard');
      } else {
        auth.signinRedirect();
      }
    }
  }, [auth, navigate]);

  // useEffect(() => {
  //   if (isScreenLoad) {
  //     if (isEmpty(settingsData) && !settingsError) {
  //       navigate('/setting');
  //     } else {
  //       navigate('/dashboard');
  //     }
  //   } else {
  //     navigate('/dashboard');
  //   }
  // }, [isScreenLoad]);

  return <Outlet />;
};

const mapStateToProps = (state: any) => ({
  settingsData: state.settings.settingsData,
  isScreenLoad: state.settings.isScreenLoad,
  settingsError: state.settings.settingsError,
});
export default connect(mapStateToProps)(AuthRoute);
